import { Mapper } from '../../../../base/utils/mapper';
import { EnablingCodeModel } from '../../../../domain/models/configuration/enabling-code.model';
import { EnablingsCodeEntity } from '../entities/enablings-code.entity';

export class EnablingsCodeImplementationRepositoryMapper extends Mapper<
  EnablingsCodeEntity,
  EnablingCodeModel
> {
  mapFrom(param: EnablingsCodeEntity): EnablingCodeModel {
    return {
      data: param.data,
      isSuccess: param.isSuccess,
      message: param.message,
      errors: param.errors,
    };
  }
  mapTo(param: EnablingCodeModel): EnablingsCodeEntity {
    return {
      data: param.data,
      isSuccess: param.isSuccess,
      message: param.message,
      errors: param.errors,
    };
  }
}
